import { Configuration, ItemApi, ItemModelODataResultCollection } from "api";
import {
  apiResponseTransformer,
  baseApiConfig,
  PaginatedApiResponse,
  validateApiResponse,
} from "./apiHelpers";

class ItemService {
  private itemApi!: ItemApi;

  constructor(config: Configuration = baseApiConfig) {
    this.itemApi = new ItemApi(config);
  }

  getProductList(
    cardCode: string
  ): Promise<PaginatedApiResponse<ItemModelODataResultCollection>> {
    return this.itemApi
      .apiItemGetListByCardCodeGet({ cardCode })
      .then(apiResponseTransformer)
      .then(validateApiResponse("Product list failed to load"));
  }
}

export default ItemService;
